// extracted by mini-css-extract-plugin
export default {"Authors":"Authors_Authors__QTPU1"};